import React from 'react'
import { Link } from 'react-router-dom'

function EULA() {
  return (
    <main className="py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h1 className="display-5 fw-bold mb-4" style={{
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                letterSpacing: '-0.02em'
              }}>
                End User License Agreement
              </h1>
              
              <p className="text-muted mb-4" style={{
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                fontSize: '16px',
                lineHeight: '24px'
              }}>
                <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>

              <div style={{
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                fontSize: '16px',
                lineHeight: '28px',
                color: '#181a25'
              }}>
                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    1. Agreement to Terms
                  </h2>
                  <p className="mb-3">
                    This End User License Agreement ("EULA" or "Agreement") is a legal agreement between you ("User," "you," or "your") and JobsReadyAI ("we," "our," "us," or "Company") governing your use of the JobsReadyAI service, including our website, software, applications, and related services (collectively, the "Service").
                  </p>
                  <p>
                    By accessing, downloading, installing, or using the Service, you agree to be bound by the terms and conditions of this EULA. If you do not agree to these terms, you must not use the Service and should discontinue use immediately.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    2. License Grant
                  </h2>
                  <p className="mb-3">
                    Subject to your compliance with this EULA, we grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your personal, non-commercial use in connection with your job search activities.
                  </p>
                  <p>
                    This license does not include any right to:
                  </p>
                  <ul className="mb-3">
                    <li>Resell, redistribute, or sublicense the Service</li>
                    <li>Use the Service for any commercial purpose without our express written consent</li>
                    <li>Reverse engineer, decompile, or disassemble any part of the Service</li>
                    <li>Remove, alter, or obscure any proprietary notices or labels on the Service</li>
                    <li>Use the Service in any manner that violates applicable laws or regulations</li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    3. User Accounts and Registration
                  </h2>
                  <p className="mb-3">
                    To use certain features of the Service, you must create an account. You agree to:
                  </p>
                  <ul className="mb-3">
                    <li>Provide accurate, current, and complete information during registration</li>
                    <li>Maintain and promptly update your account information</li>
                    <li>Maintain the security of your account credentials</li>
                    <li>Accept responsibility for all activities that occur under your account</li>
                    <li>Notify us immediately of any unauthorized use of your account</li>
                    <li>Not share your account credentials with any third party</li>
                  </ul>
                  <p>
                    You are responsible for maintaining the confidentiality of your account and password. We are not liable for any loss or damage arising from your failure to protect your account information.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    4. Acceptable Use
                  </h2>
                  <p className="mb-3">You agree not to use the Service to:</p>
                  <ul className="mb-3">
                    <li>Violate any applicable local, state, national, or international law or regulation</li>
                    <li>Infringe upon the rights of others, including intellectual property rights</li>
                    <li>Transmit any malicious code, viruses, or harmful data</li>
                    <li>Attempt to gain unauthorized access to the Service or related systems</li>
                    <li>Interfere with or disrupt the Service or servers connected to the Service</li>
                    <li>Use automated systems (bots, scrapers, etc.) to access the Service without permission</li>
                    <li>Impersonate any person or entity or misrepresent your affiliation with any entity</li>
                    <li>Collect or harvest information about other users without their consent</li>
                    <li>Use the Service to create, generate, or distribute content that is illegal, harmful, or violates third-party rights</li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    5. Intellectual Property Rights
                  </h2>
                  <p className="mb-3">
                    The Service, including its original content, features, functionality, design, logos, trademarks, and software, is owned by JobsReadyAI and is protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property laws.
                  </p>
                  <p className="mb-3">
                    You acknowledge that:
                  </p>
                  <ul className="mb-3">
                    <li>All rights, title, and interest in and to the Service remain with JobsReadyAI</li>
                    <li>You do not acquire any ownership rights by using the Service</li>
                    <li>You may not use our trademarks, logos, or other proprietary information without our prior written consent</li>
                  </ul>
                  <p>
                    You retain ownership of any content you submit, post, or display through the Service. By submitting content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and distribute such content solely for the purpose of providing and improving the Service.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    6. Payment Terms and Credits
                  </h2>
                  <p className="mb-3">
                    Certain features of the Service may require payment or the use of credits. By purchasing credits or subscribing to paid features, you agree to:
                  </p>
                  <ul className="mb-3">
                    <li>Pay all fees and charges associated with your use of the Service</li>
                    <li>Provide accurate payment information</li>
                    <li>Authorize us to charge your payment method for all applicable fees</li>
                    <li>Understand that all fees are non-refundable unless otherwise stated or required by law</li>
                    <li>Accept that credits may expire according to our credit expiration policy</li>
                    <li>Accept that pricing may change with reasonable notice</li>
                  </ul>
                  <p>
                    We reserve the right to change our pricing at any time. We will provide reasonable notice of any price changes. Continued use of the Service after a price change constitutes acceptance of the new pricing.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    7. AI-Generated Content
                  </h2>
                  <p className="mb-3">
                    The Service uses artificial intelligence to generate content, including but not limited to job summaries, resume suggestions, and interview preparation materials. You acknowledge and agree that:
                  </p>
                  <ul className="mb-3">
                    <li>AI-generated content is provided for informational and assistance purposes only</li>
                    <li>You are responsible for reviewing, editing, and verifying all AI-generated content before use</li>
                    <li>We do not guarantee the accuracy, completeness, or suitability of AI-generated content</li>
                    <li>You should not rely solely on AI-generated content for important decisions</li>
                    <li>AI-generated content may contain errors, inaccuracies, or outdated information</li>
                    <li>You are solely responsible for any content you submit to employers or third parties, regardless of whether it was AI-generated</li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    8. Service Availability and Modifications
                  </h2>
                  <p className="mb-3">
                    We strive to provide reliable service but do not guarantee that the Service will be available at all times or free from errors, interruptions, or defects. We reserve the right to:
                  </p>
                  <ul className="mb-3">
                    <li>Modify, suspend, or discontinue any part of the Service at any time</li>
                    <li>Perform maintenance that may temporarily interrupt service</li>
                    <li>Update or change features, functionality, or content of the Service</li>
                    <li>Impose limits on usage or restrict access to certain features</li>
                  </ul>
                  <p>
                    We are not liable for any loss or damage resulting from service interruptions, modifications, or discontinuation.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    9. Termination
                  </h2>
                  <p className="mb-3">
                    You may terminate your account at any time by contacting us or using the account deletion feature in the Service.
                  </p>
                  <p className="mb-3">
                    We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, including but not limited to:
                  </p>
                  <ul className="mb-3">
                    <li>Violation of this EULA or our Privacy Policy</li>
                    <li>Fraudulent, abusive, or illegal activity</li>
                    <li>Non-payment of fees</li>
                    <li>Extended periods of account inactivity</li>
                    <li>At our sole discretion for any reason</li>
                  </ul>
                  <p>
                    Upon termination, your right to use the Service will immediately cease. We may delete your account and data in accordance with our Privacy Policy. Provisions of this EULA that by their nature should survive termination will survive, including sections on intellectual property, disclaimers, and limitation of liability.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    10. Disclaimers
                  </h2>
                  <p className="mb-3">
                    THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
                  </p>
                  <ul className="mb-3">
                    <li>IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT</li>
                    <li>WARRANTIES THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, ERROR-FREE, OR FREE FROM VIRUSES</li>
                    <li>WARRANTIES REGARDING THE ACCURACY, RELIABILITY, OR QUALITY OF ANY INFORMATION OBTAINED THROUGH THE SERVICE</li>
                    <li>WARRANTIES THAT THE SERVICE WILL MEET YOUR REQUIREMENTS OR EXPECTATIONS</li>
                  </ul>
                  <p>
                    We do not warrant that job postings, AI-generated content, or any information provided through the Service is accurate, complete, or up-to-date. We are not responsible for the content of third-party websites or services linked to or from the Service.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    11. Limitation of Liability
                  </h2>
                  <p className="mb-3">
                    TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL JOBSREADYAI, ITS AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, OR LICENSORS BE LIABLE FOR:
                  </p>
                  <ul className="mb-3">
                    <li>ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES</li>
                    <li>LOSS OF PROFITS, REVENUE, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES</li>
                    <li>DAMAGES RESULTING FROM YOUR USE OR INABILITY TO USE THE SERVICE</li>
                    <li>DAMAGES RESULTING FROM UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR DATA</li>
                    <li>DAMAGES RESULTING FROM THE CONDUCT OF ANY THIRD PARTY ON THE SERVICE</li>
                  </ul>
                  <p className="mb-3">
                    OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THE USE OF OR INABILITY TO USE THE SERVICE SHALL NOT EXCEED THE AMOUNT YOU PAID TO US IN THE TWELVE (12) MONTHS PRIOR TO THE EVENT GIVING RISE TO THE LIABILITY, OR ONE HUNDRED DOLLARS ($100), WHICHEVER IS GREATER.
                  </p>
                  <p>
                    Some jurisdictions do not allow the exclusion or limitation of certain damages, so some of the above limitations may not apply to you.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    12. Indemnification
                  </h2>
                  <p>
                    You agree to defend, indemnify, and hold harmless JobsReadyAI, its affiliates, officers, directors, employees, agents, and licensors from and against any claims, liabilities, damages, losses, and expenses, including without limitation reasonable attorney's fees and costs, arising out of or in any way connected with: (a) your access to or use of the Service; (b) your violation of this EULA; (c) your violation of any third-party right, including without limitation any intellectual property right, publicity, confidentiality, property, or privacy right; or (d) any claim that your content caused damage to a third party.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    13. Third-Party Services and Links
                  </h2>
                  <p className="mb-3">
                    The Service may contain links to third-party websites, services, or resources. We are not responsible for the availability, accuracy, content, or policies of third-party services. Links to third-party services do not imply our endorsement of such services.
                  </p>
                  <p>
                    Your interactions with third-party services are solely between you and the third party. We are not liable for any loss or damage resulting from your use of third-party services.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    14. Privacy
                  </h2>
                  <p>
                    Your use of the Service is also governed by our Privacy Policy. Please review our Privacy Policy to understand how we collect, use, and protect your information. By using the Service, you consent to the collection and use of your information as described in our Privacy Policy.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    15. Email Communications
                  </h2>
                  <p className="mb-3">
                    By creating an account and using the Service, you agree to receive email communications from us, including:
                  </p>
                  <ul className="mb-3">
                    <li><strong>Welcome Emails:</strong> When you sign up, we will send you a welcome email to help you get started with the Service.</li>
                    <li><strong>Onboarding Reminders:</strong> We may send you reminder emails to help you complete your profile or import your first job posting if you haven't done so within a reasonable time after signing up.</li>
                    <li><strong>Service Updates:</strong> We may send you important updates about the Service, including changes to this Agreement, new features, or service interruptions.</li>
                    <li><strong>Account Notifications:</strong> We may send you notifications related to your account, such as credit balance updates, payment confirmations, or security alerts.</li>
                  </ul>
                  <p className="mb-3">
                    <strong>Unsubscribing:</strong> You may unsubscribe from marketing and reminder emails at any time by clicking the "unsubscribe" link included in each email, or by contacting us at support@jobsreadyai.com. However, you may not unsubscribe from essential service-related communications, such as account security alerts or important service updates, as these are necessary for the proper functioning of your account.
                  </p>
                  <p>
                    We use third-party email service providers (including Sender.net) to deliver these communications. By using the Service, you consent to our use of such providers and acknowledge that your email address may be processed by these services in accordance with their privacy policies and our Privacy Policy.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    16. Governing Law and Dispute Resolution
                  </h2>
                  <p className="mb-3">
                    This EULA shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions. Any disputes arising out of or relating to this EULA or the Service shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association, except where prohibited by law.
                  </p>
                  <p>
                    You agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, consolidated, or representative action. If for any reason a claim proceeds in court rather than in arbitration, you waive any right to a jury trial.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    17. Changes to This EULA
                  </h2>
                  <p className="mb-3">
                    We reserve the right to modify this EULA at any time. We will notify you of any material changes by:
                  </p>
                  <ul className="mb-3">
                    <li>Posting the updated EULA on this page</li>
                    <li>Updating the "Last Updated" date</li>
                    <li>Sending you an email notification (if you have provided an email address)</li>
                    <li>Displaying a notice within the Service</li>
                  </ul>
                  <p>
                    Your continued use of the Service after any changes to this EULA constitutes your acceptance of the modified terms. If you do not agree to the changes, you must stop using the Service and may terminate your account.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    18. Severability
                  </h2>
                  <p>
                    If any provision of this EULA is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that this EULA will otherwise remain in full force and effect and enforceable.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    19. Entire Agreement
                  </h2>
                  <p>
                    This EULA, together with our Privacy Policy, constitutes the entire agreement between you and JobsReadyAI regarding the Service and supersedes all prior agreements and understandings, whether written or oral, relating to the Service.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3" style={{
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif"
                  }}>
                    20. Contact Us
                  </h2>
                  <p className="mb-3">
                    If you have any questions about this EULA, please contact us:
                  </p>
                  <p className="mb-2">
                    <strong>Email:</strong> legal@jobsreadyai.com
                  </p>
                  <p>
                    <strong>Website:</strong> <a href="/" className="text-primary">www.jobsreadyai.com</a>
                  </p>
                </section>
              </div>

              <div className="mt-5 pt-4 border-top">
                <Link to="/" className="btn btn-primary">
                  ← Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
  )
}

export default EULA




